<div class="box">
  <app-center-setting></app-center-setting>
  <div style="margin-top: 2.8125rem;">
    <app-center-linker-volunteer></app-center-linker-volunteer>
  </div>
  <div style="margin-top: 2.8125rem;">
    <app-cell-group-setting></app-cell-group-setting>
  </div>
</div>